import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21c31b81"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contactContainer" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "contactElement" }, "Contacto", -1))
const _hoisted_3 = { class: "contactSection" }
const _hoisted_4 = { class: "contactElement" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Correo:", -1))
const _hoisted_6 = { class: "contactElement" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Telefono:", -1))
const _hoisted_8 = { class: "contactElement contactElement__button" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "contactSection" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Actualiza la información de contacto para el proyecto actual.", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "contactElement",
  for: ""
}, "Correo", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "contactElement",
  for: ""
}, "Teléfono", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "contactElement",
  for: ""
}, "Dirección para agendar reuniones", -1))
const _hoisted_15 = {
  key: 0,
  class: "contactElement"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, " border_color ", -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, " upgrade ", -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, " block ", -1))
const _hoisted_21 = [
  _hoisted_20
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (!_ctx.editSessionOn)
      ? (_openBlock(), _createBlock(_Transition, { key: 0 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, [
                _hoisted_5,
                _createTextVNode(" " + _toDisplayString(_ctx.contact.email), 1)
              ]),
              _createElementVNode("span", _hoisted_6, [
                _hoisted_7,
                _createTextVNode(" " + _toDisplayString(_ctx.contact.phone), 1)
              ]),
              _createElementVNode("button", _hoisted_8, [
                _createElementVNode("a", {
                  href: _ctx.contact.meetingsUrl,
                  target: "_blank"
                }, "Agenda una reunión", 8, _hoisted_9)
              ])
            ])
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_Transition, { key: 1 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _hoisted_12,
              _withDirectives(_createElementVNode("input", {
                class: "contactElement",
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.contactUpdate.email) = $event))
              }, null, 512), [
                [_vModelText, _ctx.contactUpdate.email]
              ]),
              _hoisted_13,
              _withDirectives(_createElementVNode("input", {
                class: "contactElement",
                type: "text",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.contactUpdate.phone) = $event))
              }, null, 512), [
                [_vModelText, _ctx.contactUpdate.phone]
              ]),
              _hoisted_14,
              _withDirectives(_createElementVNode("input", {
                class: "contactElement",
                type: "text",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.contactUpdate.meetingsUrl) = $event))
              }, null, 512), [
                [_vModelText, _ctx.contactUpdate.meetingsUrl]
              ])
            ])
          ]),
          _: 1
        })),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (_ctx.isUserAdmin || _ctx.isUserProducer)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _withDirectives(_createElementVNode("button", {
                class: "contactElement contactElement__button contactElement__button--yellow",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.activateEdition && _ctx.activateEdition(...args)))
              }, _hoisted_17, 512), [
                [_vShow, !_ctx.editSessionOn]
              ]),
              _withDirectives(_createElementVNode("button", {
                class: "contactElement contactElement__button contactElement__button--green",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.saveContactInfo && _ctx.saveContactInfo(...args)))
              }, _hoisted_19, 512), [
                [_vShow, _ctx.editSessionOn]
              ]),
              _withDirectives(_createElementVNode("button", {
                class: "contactElement contactElement__button contactElement__button--red",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.cancelEdition && _ctx.cancelEdition(...args)))
              }, _hoisted_21, 512), [
                [_vShow, _ctx.editSessionOn]
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}